import { Select, type SelectProps } from './Select'

// EP-95 T18 — canonical microsite font list, previously inline in
// PropertyMicrositeFields. Owned here so the Select-based control and the list
// stay in one place.
export const FONT_OPTIONS = [
  'Bai Jamjuree',
  'Inter',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Prompt',
  'Sarabun',
  'Kanit',
  'Noto Sans Thai',
] as const

export interface FontFamilySelectProps extends Omit<SelectProps, 'options'> {
  // Text for the reset option, rendered as `— {label} —`. NOT passed to Select
  // as a visible label (the microsite supplies its own field label). It is a
  // REAL selectable option (value=''), NOT Select's disabled `placeholder`, so
  // callers can reset font_family back to empty.
  label?: string
}

export function FontFamilySelect({ label, ...props }: FontFamilySelectProps) {
  const options = [
    { value: '', label: label ? `— ${label} —` : '—' },
    ...FONT_OPTIONS.map((f) => ({ value: f, label: f })),
  ]
  return <Select options={options} {...props} />
}
